import { call, put, retry, takeEvery, takeLatest } from "redux-saga/effects";

// Login Redux States
import * as TYPES from "./actionTypes";
import * as ACTIONS from "store/actions";
import * as API from "helpers/backend_helper";
import { getAccesTokenInfo } from "helpers/transak_api_helper";


import { updateToken } from "helpers/api_helper";
import {errorMsg, successMsg} from "helpers/toastr";

 /**
      * Used for calling auth user api
      */


function* loginUser({ payload: { user, callback } }) {


  try {
    const response = yield call(API.postLogin, user);

    callback && callback(response);
    if (response.status == "failure") {
      return yield put(ACTIONS.logInUserFailed(response.message));
    }
    yield put(ACTIONS.loginSuccess(response));
    localStorage.setItem("authUser", JSON.stringify(response));
    updateToken(response.data.Token);

 
  } catch (error) {

    yield put(ACTIONS.logInUserFailed(error?.response?.data?.message));
    errorMsg(error?.response?.data?.message);
  }
} 

function* socialLoginReq({ payload: { user, callback } }) {
  try {
    const response = yield call(API.socialLoginAPI, user)
    callback && callback(response)
    if (response.status === "failure") {
      errorMsg(response.message)
      return yield put(ACTIONS.socialLoginFail(response.message))
    }
    localStorage.setItem("authUser", JSON.stringify(response))
    localStorage.setItem("token", response.data.Token)
    updateToken(response.data.Token)
    yield put(ACTIONS.socialLoginSuccess(response));
  } catch (error) {
    yield put(ACTIONS.socialLoginFail(error.message))
  }
}


function* logoutUser({ payload: { history, role } }) {
  try {
    localStorage.removeItem("authUser");
    yield put(ACTIONS.logoutUserSuccess());
    history.push("/signin");
  } catch (error) {
    yield put(ACTIONS.apiError(error));
  }
}


function* getTokenInfo({ payload: { data, callback } }) {

  try {
    const response = yield call(getAccesTokenInfo, data);
    callback && callback(response);
    if (response?.status !=='200') {
       return yield put(ACTIONS.accessTokenFailed(response.message));
    }
    yield put(ACTIONS.accessTokenSuccess(response?.data?.response));
  } catch (error) {
    yield put(ACTIONS.accessTokenFailed(error));
  }
}


function* changePasswordSaga({ payload: { data, callback } }) {
  try {
    const response = yield call(API.postChangePassword, data);
    callback && callback(response);
    if (response?.status !=='200') {

       return yield put(ACTIONS.changePasswordFail(response.message));
    }
    yield put(ACTIONS.changePasswordSuccess(response?.data?.response));
  } catch (error) {

    // errorMsg(error?.response?.data?.message);
    callback && callback(error?.response?.data);

    yield put(ACTIONS.changePasswordFail(error));
  }
}

function* editProfileSaga({ payload: { data, callback } }) {
  try {
    const response = yield call(API.postEditProfile, data);
    callback && callback(response);
    if (response?.status !=='200') {
       return yield put(ACTIONS.editProfileFail(response.message));
    }
    yield put(ACTIONS.editProfileSuccess(response?.data?.response));
    
    yield put(ACTIONS.loginSuccess(response));
    localStorage.setItem("authUser", JSON.stringify(response));
    updateToken(response.data.Token);

  } catch (error) {

    // errorMsg(error?.response?.data?.message);
    callback && callback(error?.response?.data);

    yield put(ACTIONS.editProfileFail(error));
  }
}


function* setPasswordSaga({ payload: { data, callback } }) {
  try {
    const response = yield call(API.postSetPassword, data);
    callback && callback(response);
    if (response?.status !=='200') {

       return yield put(ACTIONS.setPasswordFail(response.message));
    }
    yield put(ACTIONS.setPasswordSuccess(response?.data?.response));
  } catch (error) {

    // errorMsg(error?.response?.data?.message);
    callback && callback(error?.response?.data);

    yield put(ACTIONS.setPasswordFail(error));
  }
}


function* authSaga() {
  yield takeEvery(TYPES.LOGIN_USER, loginUser);
  yield takeEvery(TYPES.LOGOUT_USER, logoutUser); 
  yield takeEvery(TYPES.SOCIAL_LOGIN_REQUEST,socialLoginReq)
  yield takeEvery(TYPES.GET_ACCES_TOKEN_INFO,getTokenInfo)
  yield takeEvery(TYPES.CHANGE_PASSWORD,changePasswordSaga)
  yield takeEvery(TYPES.EDIT_PROFILE,editProfileSaga)
  yield takeEvery(TYPES.SET_PASSWORD,setPasswordSaga)


}

export default authSaga;
